import React from 'react';
import { Navigation } from '../components/FormControls';
import { PhotoField } from '../components/PhotoField';
import { RetiradaStepProps } from './sectionTypes';

export const RetiradaStep = ({
  form,
  etapaCompleta,
  updateForm,
  input,
  onPrev,
  onNext,
  pessoasRetirada,
  setPessoasRetirada,
  updatePessoaRetirada,
  handlePhoto
}: RetiradaStepProps) => (
  <section className="form-section">
    <h2><span className="section-icon">👥</span>Dados de Quem Vai Retirar o Participante</h2>
    <div className="pessoa-principal">
      <h3>Pessoa Principal *</h3>
      <div className="form-group">
        <label htmlFor="nomeRetirada">Nome Completo *</label>
        <input id="nomeRetirada" type="text" required {...input('nomeRetirada')} />
      </div>
      <div className="form-row">
        <div className="form-group">
          <label htmlFor="parentescoRetirada">Parentesco *</label>
          <input id="parentescoRetirada" type="text" required {...input('parentescoRetirada')} />
        </div>
      </div>
      <PhotoField
        id="fotoRetirada"
        label="Foto da Pessoa que vai Retirar *"
        image={form.fotoUrlRetirada}
        onSelect={(event) => handlePhoto(event, (url) => updateForm('fotoUrlRetirada', url))}
        onRemove={() => updateForm('fotoUrlRetirada', '')}
      />
    </div>

    {pessoasRetirada.length > 0 && (
      <div className="pessoas-adicionais">
        <h3>Pessoas Adicionais para Retirada</h3>
        {pessoasRetirada.map((pessoa, index) => (
          <div className="pessoa-adicional" key={pessoa.id}>
            <div className="pessoa-header">
              <h4>Pessoa {index + 1}</h4>
              <button type="button" className="btn-remove-pessoa" onClick={() => setPessoasRetirada((current) => current.filter((item) => item.id !== pessoa.id))}>×</button>
            </div>
            <div className="form-group">
              <label htmlFor={`nomePessoa${pessoa.id}`}>Nome Completo *</label>
              <input id={`nomePessoa${pessoa.id}`} type="text" required value={pessoa.nome} onChange={(event) => updatePessoaRetirada(pessoa.id, { nome: event.target.value })} />
            </div>
            <div className="form-group">
              <label htmlFor={`parentescoPessoa${pessoa.id}`}>Parentesco *</label>
              <input id={`parentescoPessoa${pessoa.id}`} type="text" required value={pessoa.parentesco} onChange={(event) => updatePessoaRetirada(pessoa.id, { parentesco: event.target.value })} />
            </div>
            <PhotoField
              id={`fotoPessoa${pessoa.id}`}
              label="Foto da Pessoa *"
              image={pessoa.fotoUrl}
              onSelect={(event) => handlePhoto(event, (url) => updatePessoaRetirada(pessoa.id, { fotoUrl: url }))}
              onRemove={() => updatePessoaRetirada(pessoa.id, { fotoUrl: '' })}
            />
          </div>
        ))}
      </div>
    )}

    <div className="form-group">
      <button type="button" className="btn-add-pessoa" onClick={() => setPessoasRetirada((current) => [...current, { id: Date.now().toString(), nome: '', parentesco: '', fotoUrl: '' }])}>
        + Adicionar Outra Pessoa para Retirada
      </button>
    </div>
    <Navigation disabled={!etapaCompleta[5]} onPrev={onPrev} onNext={onNext} />
  </section>
);
